import { useCallback, useContext, useState } from "react";
import { Box, Paper, Typography, IconButton, Grid, CircularProgress, useTheme } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { VideoContext } from "../../context/video_context";
import "./drag_drop_styles.css";
import { Thumbnail } from "./Thumbnail";
import { tokens } from "../../theme";

export type DragDropFileUploadProps = {};


function DragDropFileUpload(fn: DragDropFileUploadProps) {
  const [dragOver, setDragOver] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const videoContext = useContext(VideoContext);
  const files = videoContext?.files || [];
  const setFiles = videoContext?.setFiles || (() => {
  });
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const hoverBackgroundColor = theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100];


  const handleDragOver = useCallback((event: any) => {
    event.preventDefault();
    setDragOver(true);
  }, []);

  const handleDragLeave = useCallback((event: any) => {
    event.preventDefault();
    setDragOver(false);
  }, []);

  const handleDrop = useCallback(
    (event: any) => {
      event.preventDefault();
      setDragOver(false);
      const files = event.dataTransfer.files;
      handleFilesChange(files);
    },
    []
  );

  const handleFilesChange = (files: any) => {
    setFiles([]);
    // console.log({files})
    if (files) {
      const fileArray = Array.from(files).map((file: any) =>
        file
      );
      // console.log({fileArray})
      setFiles((prevFiles: any) => prevFiles.concat(fileArray));

      // To prevent memory leaks
      Array.from(files).map((file: any) => URL.revokeObjectURL(file));
    }
  };

  const handleChange = useCallback(
    (event: any) => {
      const files = event.target.files;
      handleFilesChange(files);
    },
    []
  );


  return (
    <Box>
      <Paper
        variant="outlined"
        className="dropzone"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          // border: dragOver ? '2px solid #000' : '2px solid #aaa',
          padding: 20,
          textAlign: "center",
          cursor: "pointer",
          background: dragOver ? hoverBackgroundColor : undefined,
          position: "relative"
        }}
      >
        <input
          accept="image/*"
          style={{ display: "none" }}
          id="raised-button-file"
          multiple
          type="file"
          onChange={handleChange}
        />
        <label htmlFor="raised-button-file">
          <Box display="flex" flexDirection="column" alignItems="center">
            <IconButton color="primary" aria-label="upload picture" component="span">
              <CloudUploadIcon style={{ fontSize: 60 }} />
            </IconButton>
            <Typography style={{
              color: theme.palette.text.primary
            }}>Drag and drop files here or click to select files</Typography>
          </Box>
        </label>
        {loading && (
          <CircularProgress
            size={24}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px"
            }}
          />
        )}
      </Paper>

      <Box display={"flex"} justifyContent="flex-start" style={{ marginTop: 16, gap: "8px" }}>
        {files.map((file: any) => (
          <Thumbnail image={file} />
        ))}
      </Box>
    </Box>
  );
}

export default DragDropFileUpload;
